// extracted by mini-css-extract-plugin
export default {"CoreValueCard_container":"CoreValueCard_CoreValueCard_container__a1U2x","valueCardImgContainer":"CoreValueCard_valueCardImgContainer__j2WX7"};